// API and Site Configuration
// In React (CRA), environment variables must be prefixed with REACT_APP_
export const API_URL = process.env.REACT_APP_BACKEND_URL;
export const SITE_URL = process.env.REACT_APP_FRONTEND_URL;

// Login Admin Only Mode
// When true, hides login/registration buttons from public view
export const LOGIN_ADMIN_ONLY = process.env.REACT_APP_LOGIN_ADMIN_ONLY === 'true';

// Hike Page Only Mode
// When true, restricts home page access to logged-in users only
// Useful for showing only a specific hike page to public guests
export const HIKE_PAGE_ONLY = process.env.REACT_APP_SHOW_HIKE_PAGE_ONLY === 'true';

// ALTCHA Configuration (self-hosted CAPTCHA)
// Challenge URL points to our own backend - no external services
export const ALTCHA_CHALLENGE_URL = API_URL ? `${API_URL}/auth/altcha/challenge` : null;
export const ALTCHA_ENABLED = !!ALTCHA_CHALLENGE_URL;
